import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProjectById } from '../../data/projectsDetailData';
import { PageTransition } from '../transitions/PageTransition';
import { ProjectHero } from './ProjectHero';
import { ProjectOverview } from './ProjectOverview';
import { ProjectChallenges } from './ProjectChallenges';
import { ProjectSolutions } from './ProjectSolutions';
import { ProjectResults } from './ProjectResults';
import { ProjectNavigation } from './ProjectNavigation';

export function ProjectPage() {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();

  const project = projectId ? getProjectById(projectId) : undefined;

  useEffect(() => {
    // Redirect to home if project not found
    if (projectId && !project) {
      navigate('/', { replace: true });
    }
  }, [projectId, project, navigate]);

  if (!project) {
    return null;
  }

  return (
    <PageTransition>
      <ProjectHero project={project} />
      <ProjectOverview project={project} />
      <ProjectChallenges project={project} />
      <ProjectSolutions project={project} />
      <ProjectResults project={project} />
      <ProjectNavigation projectId={project.id} />
    </PageTransition>
  );
}
